import { render, staticRenderFns } from "./TravelPathsDetail.vue?vue&type=template&id=fcd329aa&scoped=true&"
import script from "./TravelPathsDetail.vue?vue&type=script&lang=js&"
export * from "./TravelPathsDetail.vue?vue&type=script&lang=js&"
import style0 from "./TravelPathsDetail.vue?vue&type=style&index=0&id=fcd329aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd329aa",
  null
  
)

export default component.exports